{
  "id": "bwak",
  "name": "Bwak de feu",
  "sprite": "bwak",
  "radius": 12,
  "speed": 253,
  "damage": {
    "element": "feu",
    "min": 6,
    "max": 9
  },
  "attackCooldown": 1.2,
  "range": 160
}
